export default __webpack_public_path__ + "static/media/Building-a-professional-profile.bb65285c.pdf";